import React from 'react';

export const RETRO_TYPES = {
  standard: {
    label: 'Standard',
    description: 'What went well and what didn\'t',
    sections: [
      { key: 'went_well', label: 'What Went Well' },
      { key: 'didnt_go_well', label: 'What Didn\'t Go Well' },
    ],
    gradient: 'from-blue-500 to-blue-600',
    iconBg: 'bg-blue-100 dark:bg-blue-900/40',
    iconColor: 'text-blue-600 dark:text-blue-400',
    tagBg: 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
      </svg>
    ),
  },
  four_ls: {
    label: '4 L\'s',
    description: 'Liked, Learned, Lacked, Longed For',
    sections: [
      { key: 'liked', label: 'Liked' },
      { key: 'learned', label: 'Learned' },
      { key: 'lacked', label: 'Lacked' },
      { key: 'longed_for', label: 'Longed For' },
    ],
    gradient: 'from-purple-500 to-purple-600',
    iconBg: 'bg-purple-100 dark:bg-purple-900/40',
    iconColor: 'text-purple-600 dark:text-purple-400',
    tagBg: 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342" />
      </svg>
    ),
  },
  start_stop_continue: {
    label: 'Start Stop Continue',
    description: 'What to start, stop, and continue doing',
    sections: [
      { key: 'start', label: 'Start' },
      { key: 'stop', label: 'Stop' },
      { key: 'continue', label: 'Continue' },
    ],
    gradient: 'from-emerald-500 to-emerald-600',
    iconBg: 'bg-emerald-100 dark:bg-emerald-900/40',
    iconColor: 'text-emerald-600 dark:text-emerald-400',
    tagBg: 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
      </svg>
    ),
  },
  mad_sad_glad: {
    label: 'Mad Sad Glad',
    description: 'Express emotions about the sprint',
    sections: [
      { key: 'mad', label: 'Mad' },
      { key: 'sad', label: 'Sad' },
      { key: 'glad', label: 'Glad' },
    ],
    gradient: 'from-orange-500 to-orange-600',
    iconBg: 'bg-orange-100 dark:bg-orange-900/40',
    iconColor: 'text-orange-600 dark:text-orange-400',
    tagBg: 'bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
      </svg>
    ),
  },
  sailboat: {
    label: 'Sailboat',
    description: 'Wind, anchors, rocks, and the island goal',
    sections: [
      { key: 'wind', label: 'Wind (Propels Us)' },
      { key: 'anchor', label: 'Anchor (Holds Back)' },
      { key: 'rocks', label: 'Rocks (Risks)' },
      { key: 'island', label: 'Island (Goal)' },
    ],
    gradient: 'from-cyan-500 to-cyan-600',
    iconBg: 'bg-cyan-100 dark:bg-cyan-900/40',
    iconColor: 'text-cyan-600 dark:text-cyan-400',
    tagBg: 'bg-cyan-50 dark:bg-cyan-900/20 text-cyan-700 dark:text-cyan-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 01-.98-.314l-.295-.295a1.125 1.125 0 010-1.591l.13-.132a1.125 1.125 0 011.3-.21l.603.302a.809.809 0 001.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 001.528-1.732l.146-.292M6.115 5.19A9 9 0 1017.18 4.64M6.115 5.19A8.965 8.965 0 0112 3c1.929 0 3.716.607 5.18 1.64" />
      </svg>
    ),
  },
  starfish: {
    label: 'Starfish',
    description: 'Five dimensions of team reflection',
    sections: [
      { key: 'keep_doing', label: 'Keep Doing' },
      { key: 'more_of', label: 'More Of' },
      { key: 'less_of', label: 'Less Of' },
      { key: 'stop_doing', label: 'Stop Doing' },
      { key: 'start_doing', label: 'Start Doing' },
    ],
    gradient: 'from-pink-500 to-pink-600',
    iconBg: 'bg-pink-100 dark:bg-pink-900/40',
    iconColor: 'text-pink-600 dark:text-pink-400',
    tagBg: 'bg-pink-50 dark:bg-pink-900/20 text-pink-700 dark:text-pink-300',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
      </svg>
    ),
  },
} as const;

export type RetroTypeKey = keyof typeof RETRO_TYPES;

interface RetroTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: RetroTypeKey) => void;
}

export default function RetroTypeModal({ isOpen, onClose, onSelect }: RetroTypeModalProps): React.ReactElement | null {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-3xl mx-4 overflow-hidden">
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-8 py-6">
          <h3 className="text-xl font-bold text-white">
            Choose Retrospective Type
          </h3>
          <p className="text-indigo-200 text-sm mt-1">
            Select a template to structure your team's reflection
          </p>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-2 gap-4">
            {(Object.entries(RETRO_TYPES) as [RetroTypeKey, typeof RETRO_TYPES[RetroTypeKey]][]).map(([key, type]) => (
              <button
                key={key}
                onClick={() => onSelect(key)}
                className="text-left rounded-xl border-2 border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/30 hover:border-indigo-400 dark:hover:border-indigo-500 hover:bg-indigo-50/50 dark:hover:bg-indigo-950/20 hover:shadow-lg transition-all duration-200 group p-5"
              >
                <div className={`w-11 h-11 rounded-full ${type.iconBg} ${type.iconColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200`}>
                  {type.icon}
                </div>

                <div className="flex items-center gap-2 mb-1.5">
                  <h4 className="text-base font-bold text-gray-900 dark:text-gray-100 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                    {type.label}
                  </h4>
                  <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${type.tagBg}`}>
                    {type.sections.length} sections
                  </span>
                </div>

                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  {type.description}
                </p>
              </button>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
